// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/common/v1/pagination.proto (package thru.common.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/common/v1/pagination.proto.
 */
export const file_thru_common_v1_pagination: GenFile = /*@__PURE__*/
  fileDesc("Ch90aHJ1L2NvbW1vbi92MS9wYWdpbmF0aW9uLnByb3RvEg50aHJ1LmNvbW1vbi52MSKoAQoLUGFnZVJlcXVlc3QSJQoJcGFnZV9zaXplGAEgASgNQg3gQQG6SAcqBRjoBygBSACIAQESJAoKcGFnZV90b2tlbhgCIAEoCUIL4EEBukgFcgMYgARIAYgBARIiCghvcmRlcl9ieRgDIAEoCUIL4EEBukgFcgMYgAJIAogBAUIMCgpfcGFnZV9zaXplQg0KC19wYWdlX3Rva2VuQgsKCV9vcmRlcl9ieSJyCgxQYWdlUmVzcG9uc2USIQoPbmV4dF9wYWdlX3Rva2VuGAEgASgJQgPgQQFIAIgBARIcCgp0b3RhbF9zaXplGAIgASgEQgPgQQFIAYgBAUISChBfbmV4dF9wYWdlX3Rva2VuQg0KC190b3RhbF9zaXplQssBChJjb20udGhydS5jb21tb24udjFCD1BhZ2luYXRpb25Qcm90b1ABWkRnaXRodWIuY29tL1VudG8tTGFicy90aHJ1LW5ldC9ncnBjL3BrZy9wcm90by90aHJ1L2NvbW1vbi92MTtjb21tb252MaICA1RDWKoCDlRocnUuQ29tbW9uLlYxugIDVEhVygIOVGhydVxDb21tb25cVjHiAhpUaHJ1XENvbW1vblxWMVxHUEJNZXRhZGF0YeoCEFRocnU6OkNvbW1vbjo6VjFiBnByb3RvMw", [file_buf_validate_validate, file_google_api_field_behavior]);

/**
 * PageRequest contains pagination parameters for listing RPCs.
 *
 * @generated from message thru.common.v1.PageRequest
 */
export type PageRequest = Message<"thru.common.v1.PageRequest"> & {
  /**
   * Maximum number of items to return in a single response.
   *
   * @generated from field: optional uint32 page_size = 1;
   */
  pageSize?: number | undefined;

  /**
   * Token identifying the position to resume from.
   *
   * @generated from field: optional string page_token = 2;
   */
  pageToken?: string | undefined;

  /**
   * Optional ordering specification in "field [asc|desc]" form.
   *
   * @generated from field: optional string order_by = 3;
   */
  orderBy?: string | undefined;
};

/**
 * Describes the message thru.common.v1.PageRequest.
 * Use `create(PageRequestSchema)` to create a new message.
 */
export const PageRequestSchema: GenMessage<PageRequest> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_pagination, 0);

/**
 * PageResponse captures pagination metadata returned with list results.
 *
 * @generated from message thru.common.v1.PageResponse
 */
export type PageResponse = Message<"thru.common.v1.PageResponse"> & {
  /**
   * Token to retrieve the next page of results, if any.
   *
   * @generated from field: optional string next_page_token = 1;
   */
  nextPageToken?: string | undefined;

  /**
   * Total number of items available when known.
   *
   * @generated from field: optional uint64 total_size = 2;
   */
  totalSize?: bigint | undefined;
};

/**
 * Describes the message thru.common.v1.PageResponse.
 * Use `create(PageResponseSchema)` to create a new message.
 */
export const PageResponseSchema: GenMessage<PageResponse> = /*@__PURE__*/
  messageDesc(file_thru_common_v1_pagination, 1);

